import { useTheme } from "@emotion/react";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  useMediaQuery,
} from "@mui/material";
import { forwardRef, useContext, useState } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ApproveEstimateDialog = ({
  open,
  setOpen,
  actionAreaContent,
  containerStyle,
  ...props
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      TransitionComponent={Transition}
      fullScreen={true}
      fullWidth={true}
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle>Review and Approve Order</DialogTitle>
      <DialogContent>
        <Box>{props.children}</Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
        {actionAreaContent()}
      </DialogActions>
    </Dialog>
  );
};

export default ApproveEstimateDialog;
